import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidDictationDigital } from '../../../../mechanics/rid-dictation-digital/rid-dictation-digital';

@Component({
  selector: 'app-dictation-digital-page',
  imports: [RidDictationDigital],
  templateUrl: './dictation-digital-page.html',
})
export class DictationDigitalPage {
  protected readonly $router = inject(Router);
}
